import { render, staticRenderFns } from "./kdbds.vue?vue&type=template&id=ce3556ec&"
import script from "./kdbds.vue?vue&type=script&lang=js&"
export * from "./kdbds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports